import responsiveValues from './responsive-values';
import gsap from 'gsap'
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader';
import { ScrollTrigger} from 'gsap/ScrollTrigger'

// SETUP VARIABLES
var loaded = false
let values = responsiveValues(window.innerWidth)
// console.log(values)
/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')
// console.log(canvas)


// Loading
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/draco/')
const textureLoader = new THREE.TextureLoader()
const steelMatcapTexture = textureLoader.load('./textures/steel.png')

var jetMixerGroup;

//Material
const steelMaterial = new THREE.MeshMatcapMaterial()
steelMaterial.matcap = steelMatcapTexture

//Mesh
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)
gltfLoader.load(
    './products_model/jet-mixer/jet-mixer.glb',
    (gltf) => {
        // const boltsMesh = gltf.scene.children.find(child => child.name === 'bolts')
        gltf.scene.traverse((child) => {
            child.material = steelMaterial;
        })
        gltf.scene.scale.set(1,1,1)
        scene.add(gltf.scene);
        jetMixerGroup = scene.children.find(child => child.name === 'Scene')

        setUpAnimation(jetMixerGroup)
        loaded = true
        // console.log(scene)
    }
)
// Scene
const scene = new THREE.Scene()

// Object
// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // ScrollTrigger.refresh()

    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    values = responsiveValues(sizes.width)
    // console.log(values)
})

// Camera
// https://stackoverflow.com/a/40889658/12268569
const camera = new THREE.PerspectiveCamera(20, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 10
scene.add(camera)


// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor(0x0d0e11)

// Animate
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    // controls.update()

    // if (loaded){
    //     camera.lookAt(jetMixerGroup.position)
    //     scene.children[3].rotation.x += 0.0011 * (elapsedTime %100)
    // }
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

function setUpAnimation(model){
    // scrollSnapping()
    basicSets()
    componentsSection()
    workingSection()
    features()
    applications()
}

function goToSection(i, anim) {
  gsap.to(window, {
    scrollTo: {y: i*innerHeight, autoKill: false},
    duration: 1
  });
  if(anim) {
    anim.restart();
  }
}
// gsap.registerPlugin(ScrollToPlugin);
function scrollSnapping(){
    gsap.utils.toArray("section").forEach((section, i) => {
      ScrollTrigger.create({
        trigger: section,
        // start: "top top",
        markers: true,
        onEnter: (self) => {
            console.log(self.getVelocity())
            goToSection(i)
        }
      });
      ScrollTrigger.create({
        trigger: section,
        // start: "bottom bottom",
        // markers: true,
        onEnterBack: (self) => {
            console.log(self.getVelocity())
            goToSection(i)
        }
      });
    });
}
function basicSets(){
    gsap.set(jetMixerGroup.position, {
        x: values.objPosX,
        y: values.objPosY,
        z: values.objPosZ
    })
    gsap.set(jetMixerGroup.rotation, {
        x: Math.PI/2,
        y: values.objRotY,
        z: -Math.PI/1
    })
    gsap.to(jetMixerGroup.position, {
        y: values.entryObjPosY,
        duration: 2,
        ease: 'Power2.easeOut',
    })
    gsap.fromTo(jetMixerGroup.rotation, {
        z: 0,
    }, {
        repeat: -1,
        z: 2*Math.PI,
        duration: 10,
        ease: 'linear'
    })
}
function componentsSection () {
    const tl = new gsap.timeline()
    gsap.timeline({
        scrollTrigger: {
          trigger: ".components-section",
          start: "center center",
          end: "bottom center",
          scrub: true,
          pin: '.pin-components',
          anticipatePin: 1,
        }
      }).from('.components-div > h1, .components-div>p', {
            opacity: 0,
            y: '-100%',
            ease: 'ease.out',
        })
        .from(".component-name",  {
            x: gsap.utils.wrap([-100, 100]),
            opacity: 0,
        }, " ")

    gsap.to(jetMixerGroup.position, {
        x: values.ComponentsPosX,
        z: values.ComponentPosZ,
        scrollTrigger: {
            trigger: '.components-section',
            start: 'top bottom-=100',
            scrub: true,
            end: 'bottom bottom',
        },
    })
    gsap.to(jetMixerGroup.rotation, {
        y: values.ComponentsRotY,
        ease: 'ease.in',
        scrollTrigger: {
            trigger: '.components-section',
            start: 'top bottom-=100',
            scrub: true,
            end: 'bottom bottom',
        }
    })

    gsap.to(scene.children[0].position, {
        y: values.CameraPosY,
        ease: 'Power1.easeOut',
        scrollTrigger: {
            trigger: '.working-section',
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
        }
    })

    return tl
}
function workingSection(){
    gsap.timeline({
        scrollTrigger: {
          trigger: ".working-section",
          start: "top bottom-=50",
          end: "center center+=100",
          scrub: true,
          once: true,
        //   markers: true,
        //   pin: '.pin-working',
          anticipatePin: 1,
        }
      }).from('.working-heading > h1', {
            opacity: 0,
            y: '-100%',
            ease: 'ease.out',
        })
        .from(".working-steps > li",  {
            x: -10,
            stagger: 0.2,
            opacity: 0,
        }, ">")
        .fromTo(".svg-image-desktop",
            {xPercent:100},
            {duration: 1, xPercent:0, ease: 'ease.out'}, "-=1")
        .fromTo(".svg-image-desktop > img",
            {xPercent:-100},
            {duration: 1, xPercent: 0, ease: 'ease.out'}, "<")

}
function features(){
    const featuresArray = document.querySelectorAll('.feature-icon-div')
    gsap.from(featuresArray, {
        y: -10,
        opacity: 0,
        ease: 'sine',
        stagger: 0.5,
        scrollTrigger: {
            trigger: '.features-container',
            start: 'top bottom-=100',
            scrub: true,
            end: 'bottom+=50 bottom',
            once: true,
            // markers: true,
        }
    });

}
function applications(){
    gsap.from('.applications-ul > li', {
        x: 20,
        opacity: 0,
        ease: 'sine',
        stagger: 0.1,
        scrollTrigger: {
            trigger: '.app-wht-flex',
            start: 'top bottom-=100',
            scrub: true,
            end: 'bottom+=100 bottom',
            once: true,
            // markers: true,
        }
    });
    gsap.from('.column-white-links > a', {
        y: 20,
        opacity: 0,
        ease: 'ease.out',
        stagger: 0.1,
        scrollTrigger: {
            trigger: '.whitepages-container',
            start: 'top bottom-=100',
            scrub: true,
            end: 'center bottom',
            once: true,
            // markers: true,
        }
    });
}